import clsx from 'clsx';

import styles from './styles.module.scss';

type CarouselButtonVariant = 'prev' | 'next';

type CarouselButtonProps = {
  variant: CarouselButtonVariant;
  onClick: () => void;
  ariaLabel?: string;
  disabled?: boolean;
};

const iconVariantMap: Record<CarouselButtonVariant, string> = {
  prev: 'icon-v2-arrow-back',
  next: 'icon-v2-arrow-next',
};

export const CarouselButton = ({
  variant,
  onClick,
  ariaLabel,
  disabled,
}: CarouselButtonProps) => {
  return (
    <button
      className={clsx(styles.carouselButton)}
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      <i className={clsx(iconVariantMap[variant])} aria-hidden />
    </button>
  );
};
